export const SET_SURVEY   = 'SET_SURVEY';
export const UPDATE_QUESTION   = 'UPDATE_QUESTION';
export const FETCH_SURVEYS   = 'FETCH_SURVEYS';
export const CLEAR_SURVEY   = 'CLEAR_SURVEY';
export const FETCH_SURVEY_FORM   = 'FETCH_SURVEY_FORM';